module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 172.8b15373b.png";